import CustomActionPane from './CustomActionPane';

export default CustomActionPane;
export { CustomActionPane };
